// Simple session-based admin auth for the private CRM at /mtnadmin.
// Credentials are intentionally hardcoded per product spec and this area is
// NOT linked from anywhere on the public site.

export const ADMIN_USERNAME = 'AlbaniaZeraAdmin';
export const ADMIN_PASSWORD = 'AlbaniaZeraAdmin';
const STORAGE_KEY = 'mtnadmin_session';

export function isAdminAuthenticated(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'authenticated';
  } catch {
    return false;
  }
}

export function loginAdmin(username: string, password: string): boolean {
  if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'authenticated');
    } catch {
      /* ignore */
    }
    return true;
  }
  return false;
}

export function logoutAdmin(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
